import { FaSpinner } from 'react-icons/fa';

import { styled } from '../theme';

export default styled(FaSpinner)(({ theme }) => ({
    animation: theme.animations.spin,
}));
